export const GET_SITES_SUCCESS = "GET_SITES_SUCCESS";
export const UPDATE_SITE_SUCCESS = "UPDATE_SITEUPDATE_SUCCESS";
export const ADD_SITE_SUCCESS = "ADD_SITE_SUCCESS";
export const ACTIVATE_SITE_SUCCESS = "ACTIVATE_SITE_SUCCESSs";
export const IN_ACTIVATE_SITE_SUCCESS = "IN_ACTIVATE_SITE_SUCCESS";
